import { render, staticRenderFns } from "./TehtavatHallitusTehtavaDialog.vue?vue&type=template&id=1dd8a746"
import script from "./TehtavatHallitusTehtavaDialog.vue?vue&type=script&lang=js"
export * from "./TehtavatHallitusTehtavaDialog.vue?vue&type=script&lang=js"
import style0 from "./TehtavatHallitusTehtavaDialog.vue?vue&type=style&index=0&id=1dd8a746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports